






































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Debounce } from "vue-debounce-decorator";

interface SelectOption {
  value: number | any;
  label: string;
}
@Component
export default class TransparenciaDecretos extends Vue {
  private base = process.env.VUE_APP_BASE_URL;
  private dialogRelacionados: any = false;
  private idDecretoSelected: any = null;
  private relacionados: any = [];
  private decretos: any = [];

  private total: any = 0;
  private currentPage: any = 1;
  private sinDecretos: any = false;
  private paginaCargada: any = false;
  private tipoOptions: SelectOption[] = [];
  private tipoList: SelectOption[] = [];
  private dataTipo: SelectOption = {
    value: null,
    label: "Seleccione Tipo",
  };
  private disableSubTipo: boolean = true;
  private subTiposOptions: SelectOption[] = [];
  private subTipoListOriginal: any[] = [];
  private subTipoList: SelectOption[] = [];
  private dataSubTipo: SelectOption = {
    value: null,
    label: "Seleccione Sub-Tipo",
  };
  private categoriaOptions: SelectOption[] = [
    { value: null, label: "Todos" },
    { value: "B", label: "B" },
    { value: "C", label: "C" },
    { value: "D", label: "D" },
    { value: "E", label: "E" },
  ];
  private dataCategoria: SelectOption = {
    value: null,
    label: "Seleccione Categoría",
  };
  private formattedFechaInicio: any = "";
  private formattedFechaTermino: any = "";
  private inputTexto: any = "";
  private inputNumero: any = "";
  private filtros: any = {
    categoria: "",
    tipo: -1,
    subTipo: -1,
    fechaInicio: null,
    fechaTermino: null,
    texto: "",
    numero: ""
  };
  private localeCalendar: any = {
    days: [
      "Domingo",
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Sábado",
    ],
    daysShort: ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sab"],
    months: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ],
    monthsShort: [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Oct",
      "Nov",
      "Dic",
    ],
  };

  @Watch("inputTexto")
  private onInputTextoChanged(newValue: any) {
    this.filtros.texto = newValue;
    this.getDecretos();
  }

  @Watch("inputNumero")
  private onInputNumeroChanged(newValue: any) {
    this.filtros.numero = newValue;
    this.getDecretos();
  }

  @Watch("dataCategoria")
  private changeCategoria(newValue: any) {
    this.filtros.categoria = newValue.value;
    this.getDecretos();
  }

  @Watch("dataTipo")
  private changeTipo(newValue: any) {
    this.filtros.tipo = newValue.value;
    this.subTiposOptions = [];
    this.subTiposOptions.push({
      value: -1,
      label: "Todos"
    });
    this.dataSubTipo = {
      value: -1,
      label: "Todos"
    };
    if (newValue.value == -1) {
      this.subTipoListOriginal.map(subTipo => {
        this.subTiposOptions.push({
          value: subTipo.id,
          label: subTipo.nombre
        });
      })
      this.subTipoList = [...this.subTiposOptions];
      this.disableSubTipo = true;
    } else {
      this.subTipoListOriginal.map(subTipo => {
        if (subTipo.idTipo == newValue.value) {
          this.subTiposOptions.push({
            value: subTipo.id,
            label: subTipo.nombre
          });
        }
      });
      this.subTipoList = [...this.subTiposOptions];
      this.disableSubTipo = false;
    }
    this.getDecretos();
  }

  @Watch("dataSubTipo")
  private changeSubTipo(newValue: any) {
    this.filtros.subTipo = newValue.value;
    this.getDecretos();
  }

  @Watch("formattedFechaInicio")
  private changeFormattedFechaInicio(newValue: any) {
    if (typeof newValue === "object") {
      const day = newValue
        .getDate()
        .toString()
        .padStart(2, "0");
      const month = (newValue.getMonth() + 1).toString().padStart(2, "0");
      const year = newValue.getFullYear();
      newValue = `${year}-${month}-${day}`;
    }

    const fecha_inicio =
      newValue.substring(6, 10) +
      "-" +
      newValue.substring(3, 5) +
      "-" +
      newValue.substring(0, 2) +
      "T12:00:00";

    if (fecha_inicio.length <= 18) {
      this.filtros.fechaInicio = null;
      return;
    }

    const dateParts = fecha_inicio
      .split(/-|\s|:/)
      .map((part) => parseInt(part, 10));
    const año = dateParts[0];
    const mes = dateParts[1];
    const dia = dateParts[2];
    const result = this.validFechaNacimiento(año, mes, dia);
    if (result == false) {
      this.formattedFechaInicio = "";
    }

    let fecha = new Date(fecha_inicio);

    this.filtros.fechaInicio = fecha;
    if (this.filtros.fechaInicio == "Invalid Date") {
      this.filtros.fechaInicio = null;
    }
    this.getDecretos();
  }

  @Watch("formattedFechaTermino")
  private changeFormattedFechaTermino(newValue: any) {
    if (typeof newValue === "object") {
      const day = newValue
        .getDate()
        .toString()
        .padStart(2, "0");
      const month = (newValue.getMonth() + 1).toString().padStart(2, "0");
      const year = newValue.getFullYear();
      newValue = `${year}-${month}-${day}`;
    }

    const fecha_termino =
      newValue.substring(6, 10) +
      "-" +
      newValue.substring(3, 5) +
      "-" +
      newValue.substring(0, 2) +
      "T12:00:00";

    if (fecha_termino.length <= 18) {
      this.filtros.fechaTermino = null;
      return;
    }

    const dateParts = fecha_termino
      .split(/-|\s|:/)
      .map((part) => parseInt(part, 10));
    const año = dateParts[0];
    const mes = dateParts[1];
    const dia = dateParts[2];
    const result = this.validFechaNacimiento(año, mes, dia);
    if (result == false) {
      this.formattedFechaTermino = "";
    }

    let fecha = new Date(fecha_termino);

    this.filtros.fechaTermino = fecha;
    if (this.filtros.fechaTermino == "Invalid Date") {
      this.filtros.fechaTermino = null;
    }
    this.getDecretos();
  }

  @Watch("currentPage")
  private changeCurrentPage(newValue: any) {
    if (newValue >= 0 && newValue <= Math.ceil(this.total / 10)) {
      this.getDecretos();
    }
  }

  private mounted() {
    this.getFiltros();
    this.getDecretos();
  }

  private getFiltros() {
    const loadingFiltros = this.$q.loading.show({
      delay: 100, // ms
    });
    this.$axios
      .get(
        "https://intranet.puntaarenas.cl/api/filtros/decretos/transparencia"
      )
      .then((res: any) => {
        this.tipoOptions = [];
        this.tipoOptions.push({
          value: -1,
          label: "Todos",
        });
        for (let i = 0; i < res.data.tipos.length; i++) {
          this.tipoOptions.push({
            value: res.data.tipos[i].id,
            label: res.data.tipos[i].nombre
          });
        }
        this.tipoList = [...this.tipoOptions];
        this.subTiposOptions = [];
        this.subTiposOptions.push({
          value: -1,
          label: "Todos"
        });
        if (res.data.subTipos) {
          this.subTipoListOriginal = [...res.data.subTipos];
        }
        for (let i = 0; i < res.data.subTipos.length; i++) {
          this.subTiposOptions.push({
            value: res.data.subTipos[i].id,
            label: res.data.subTipos[i].nombre
          });
        }
        this.subTipoList = [...this.subTiposOptions];
        loadingFiltros;
      })
      .catch((err: any) => {
        this.tipoOptions = [
          {
            value: -1,
            label: "Todos",
          },
        ];
        this.subTipoList = [];
        this.subTiposOptions = [
          {
            value: -1,
            label: "Todos",
          },
        ];
        this.subTipoList = [];
        loadingFiltros;
      });
  }

  @Debounce(500)
  private getDecretos() {
    const loadingDecretos = this.$q.loading.show({
      delay: 100, // ms
    });
    let filtrosQuery = "";
    if (
      this.filtros.categoria &&
      this.filtros.categoria != null &&
      this.filtros.categoria != -1
    ) {
      filtrosQuery = filtrosQuery + "&categoria=" + this.filtros.categoria;
    }
    if (
      this.filtros.tipo &&
      this.filtros.tipo != null &&
      this.filtros.tipo != -1
    ) {
      filtrosQuery = filtrosQuery + "&tipo=" + this.filtros.tipo;
    }
    if (
      this.filtros.subTipo &&
      this.filtros.subTipo != null &&
      this.filtros.subTipo != -1
    ) {
      filtrosQuery = filtrosQuery + "&subTipo=" + this.filtros.subTipo;
    }
    if (this.filtros.fechaInicio) {
      filtrosQuery =
        filtrosQuery +
        "&fechaInicio=" +
        this.formatDate(this.filtros.fechaInicio);
    }
    if (this.filtros.fechaTermino) {
      filtrosQuery =
        filtrosQuery +
        "&fechaTermino=" +
        this.formatDate(this.filtros.fechaTermino);
    }
    if (this.filtros.texto && this.filtros.texto != "") {
      filtrosQuery = filtrosQuery + "&texto=" + this.filtros.texto;
    }
    if (this.filtros.numero && this.filtros.numero != "") {
      filtrosQuery = filtrosQuery + "&numero=" + this.filtros.numero;
    }

    this.$axios
      .get(
        "https://intranet.puntaarenas.cl/api/listado/decretos/transparencia?pagina=" +
          this.currentPage +
          filtrosQuery
      )
      .then((res: any) => {
        this.$q.loading.hide();
        if (res.data.decretos.length == 0) {
          this.sinDecretos = true;
        } else {
          this.sinDecretos = false;
        }
        this.decretos = res.data.decretos;
        this.total = res.data.total;
        this.paginaCargada = true;
        loadingDecretos;
      })
      .catch((err: any) => {
        this.$q.loading.hide();
        this.sinDecretos = true;
        this.paginaCargada = true;
        loadingDecretos;
      });
  }

  private toLink(item: any, target: any) {
    if (item && item != "") {
      window.open(this.base + item, target);
    } else {
      return;
    }
  }

  private validFechaNacimiento(año: any, mes: any, dia: any) {
    if (mes > 12) {
      return false;
    } else if (año < 1900) {
      return false;
    } else if (
      (año % 4 !== 0 &&
        año % 100 !== 0 &&
        año % 400 !== 0 &&
        dia > 28 &&
        mes == 2) ||
      (año % 4 === 0 &&
        año % 100 === 0 &&
        año % 400 === 0 &&
        dia > 29 &&
        mes == 2)
    ) {
      return false;
    }
  }

  private filterFnTipos(val: any, update: any, abort: any) {
    update(() => {
      const needle = val.toLowerCase();
      this.tipoOptions = this.tipoList.filter(
        (v: any) => v.label.toLowerCase().indexOf(needle) > -1
      );
    });
  }

  private filterFnSubTipos(val: any, update: any, abort: any) {
    update(() => {
      const needle = val.toLowerCase();
      this.subTiposOptions = this.subTipoList.filter(
        (v: any) => v.label.toLowerCase().indexOf(needle) > -1
      );
    });
  }
  private formatDate(date: any) {
    if (date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Los meses van de 0 a 11
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    } else {
      return "";
    }
  }

  private openDialog(val: any) {
    this.relacionados = val;
    this.dialogRelacionados = true;
  }
}
